import React from "react";
import {
  endometriosisBannerLeft,
  endometriosisBannerRight,
  pcosimg,
  pcosimg1,
  pcosimg2,
  pcosimg3,
  pcosimg4,
} from "../../../assets/images";
import { helpicon, helpicon1, helpicon2, liheart } from "../../../assets/icons";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import FAQ from "../../home/section/FAQ";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Endometriosis = ({ type }) => {
 const schemaData =  {
 "@context": "https://schema.org",
 "@graph": [
   {
     "@type": "MedicalCondition",
     "name": "Endometriosis",
     "alternateName": "Endometriosis",
     "description": "Understand endometriosis; its symptoms, causes, and homeopathy treatments for endometriosis. Track your health with our AI-powered app and connect with certified doctors.",
     "url": "https://holypills.in/endometriosis-symptoms-causes-treatment",
     "mainEntityOfPage": "https://holypills.in/endometriosis-symptoms-causes-treatment",
     "associatedAnatomy": {
       "@type": "AnatomicalStructure",
       "name": "Uterus"
     },
     "possibleTreatment": {
       "@type": "MedicalTherapy",
       "name": "Homeopathy"
     },
     "signOrSymptom": [
       { "@type": "MedicalSignOrSymptom", "name": "Severe menstrual cramps" },
       { "@type": "MedicalSignOrSymptom", "name": "Pain during or after intercourse" },
       { "@type": "MedicalSignOrSymptom", "name": "Chronic pelvic pain" },
       { "@type": "MedicalSignOrSymptom", "name": "Fatigue, bloating, and nausea" },
       { "@type": "MedicalSignOrSymptom", "name": "Fertility issues or difficulty conceiving" },
       { "@type": "MedicalSignOrSymptom", "name": "Heavy or irregular menstrual bleeding" },
       { "@type": "MedicalSignOrSymptom", "name": "Painful bowel movements or urination" }
     ]
   }
 ]
};


const faqData = {
 "@context": "https://schema.org",
 "@type": "FAQPage",
 "mainEntity": [
   {
     "@type": "Question",
     "name": "What is endometriosis, and how is it different from normal period pain?",
     "acceptedAnswer": {
       "@type": "Answer",
       "text": "Endometriosis is a chronic condition where tissue similar to the lining of the uterus grows outside it, leading to pain, menorrhagia, and occasional infertility. Unlike period pain that lasts a few days, endometriosis pain is more intense, persistent, and can occur outside of menstrual cycles. Many women find homeopathy for endometriosis pain and pelvic pain homeopathic remedies helpful in managing discomfort."
     }
   },
   {
     "@type": "Question",
     "name": "How is endometriosis diagnosed?",
     "acceptedAnswer": {
       "@type": "Answer",
       "text": "Diagnosis typically involves a detailed medical history, pelvic examination, ultrasound, or MRI. Early diagnosis is crucial to prevent worsening symptoms. You can book an Endometriosis consultation online to discuss symptoms with a specialist."
     }
   },
   {
     "@type": "Question",
     "name": "What is the treatment for endometriosis?",
     "acceptedAnswer": {
       "@type": "Answer",
       "text": "Since there is no permanent cure, the treatment is symptomatic; it tries to reduce the symptoms, help with fertility, and improve the quality of life. Many women nowadays prefer homeopathic treatment for endometriosis, as it is natural and free of side effects while providing relief from the pain of endometriosis."
     }
   },
   {
     "@type": "Question",
     "name": "Is endometriosis linked to infertility?",
     "acceptedAnswer": {
       "@type": "Answer",
       "text": "Yes. Endometriosis prevents fertility in cases of scarring, inflammation, or blocked Fallopian tubes, which make conception more difficult. However, with good treatment, many women with endometriosis become pregnant."
     }
   },
   {
     "@type": "Question",
     "name": "How does your app help in long-term care?",
     "acceptedAnswer": {
       "@type": "Answer",
       "text": "Holypills is designed to support patients beyond just a diagnosis. The app helps women to stay on top of their healing journey with its AI-powered tracker, allowing them to record symptoms, monitor progress, and get insights that make treatment more effective. The app also supports long-term care by offering personalized reminders, wellness reports, and easy access to expert consultations."
     }
   }
 ]
};


  const { healthPage } = PublicService();

  const pcosQuery = useQuery({
    queryKey: ["endometriosis"],
    queryFn: () => healthPage({ category: "endometriosis" }),
  });

  const detail = pcosQuery?.data?.data?.content;

  console.log(detail, "Detail");

  return (
    <>
      <Helmet defer={false}>
        <title>
          Endometriosis: Symptoms, Causes & App-Based Homeopathy Treatment
          Options
        </title>
        <meta
          name="description"
          content="Understand endometriosis; its symptoms, causes, and homeopathy treatments for endometriosis. Track your health with our AI-powered app and connect with certified doctors."
        />
        <link
          rel="canonical"
          href="https://holypills.in/endometriosis-symptoms-causes-treatment"
        ></link>
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />

        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Endometriosis: Symptoms, Causes & App-Based Homeopathy Treatment Options"
        />
        <meta
          property="og:description"
          content="Understand endometriosis; its symptoms, causes, and homeopathy treatments for endometriosis. Track your health with our AI-powered app and connect with certified doctors."
        />

        <meta
          property="og:url"
          content="https://holypills.in/endometriosis-symptoms-causes-treatment"
        />
        <meta property="og:site_name" content="Holypills"></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Endometriosis: Symptoms, Causes & App-Based Homeopathy Treatment Options"
        />
        <meta
          name="twitter:description"
          content="Understand endometriosis; its symptoms, causes, and homeopathy treatments for endometriosis. Track your health with our AI-powered app and connect with certified doctors."
        />

        <meta
          name="twitter:url"
          content="https://holypills.in/endometriosis-symptoms-causes-treatment"
        ></meta>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(faqData)}</script>
        {/* <script type="application/ld+json">
          {JSON.stringify(orgnaizationData)}
        </script> */}
      </Helmet>

      <div className="wrapper_pcos_page endometriosis">
        {/* <section className="wrap_pcos_banner">
        <figure>
          <img src={detail?.banner?.image} alt="" />
        </figure>
        <div className="wrap_bannner_content">
          <figure>
            <img src={pcosimg} alt="" />
          </figure>
          <div className="wrap_txt">
            <h1>Understanding PCOS</h1>
            <p>Causes, Symptoms & Treatment</p>
            <span>
              Polycystic Ovary Syndrome (PCOS) affects millions of women
              worldwide, impacting hormones, metabolism, and overall health.
            </span>
            <p className="effectively">Learn how to manage it effectively!</p>
          </div>

          <figure className="figure2">
            <img src={pcosimg1} alt="" />
          </figure>
        </div>
      </section> */}
        <section className="banner_sec">
          <div className="container">
            <div className="inner_part">
              <div className="left_part">
                <div className="left_image">
                  <figure>
                    <img src={endometriosisBannerLeft} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="right_part">
                <div className="right_img">
                  <figure>
                    <img src={endometriosisBannerRight} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="banner_content">
                <h1>
                  Endometriosis
                  <span>
                    Understand Symptoms, Causes & Homeopathy Treatment
                  </span>
                </h1>
                <p>
                  Endometriosis occurs when tissue similar to the uterine lining
                  grows outside the uterus, causing pain, irregular periods, and
                  fertility issues. Learn about the causes, symptoms, and
                  homeopathy treatment for Endometriosis.
                </p>
                {/* <div className="btn-box">
                  <Link to="/login" className="button blue">
                    Consult a Specialist Now
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.whatIsSection?.title}</h2>
                <p>{detail?.whatIsSection?.description}</p>
                {/* <p>
                Polycystic ovary syndrome (PCOS) is a problem with hormones that
                happens during the reproductive years. If you have PCOS, you may
                not have periods very often. Or you may have periods that last
                many days. You may also have too much of a hormone called
                androgen in your body.
              </p>
              <p>
                With PCOS, many small sacs of fluid develop along the outer edge
                of the ovary. These are called cysts. The small fluid-filled
                cysts contain immature eggs, called follicles. The follicles
                fail to regularly release eggs.
              </p>
          
              
              <ul>
                <li>
                  <img src={liheart} alt="" />
                  <span>Affects 1 in 10 women worldwide</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Can lead to infertility if left untreated</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Lifestyle changes can help manage symptoms</span>
                </li>
              </ul> */}

                <ul>
                  {detail?.whatIsSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="image" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.whatIsSection?.image} alt="image" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.commonSigns?.title}</h2>
                {/* <p>
                Discover a seamless healthcare experience with advanced
                features, including easy appointment booking, virtual
                consultations, and personalized wellness plans.
              </p> */}
                <p>{detail?.commonSigns?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.commonSigns?.signs.map((item, index) => (
                  <button key={index} className={index === 1 ? "" : ""}>
                    {item}
                  </button>
                ))}
                {/* <button>Irregular or missed periods</button>
              <button className="active">
                Excessive hair growth (face, chest, back)
              </button>
              <button>Acne and oily skin</button>
              <button>Weight gain and difficulty losing weight</button>
              <button>Thinning hair or hair loss</button>
              <button>Mood swings and depression</button>
              <button>Dark patches on the skin (Acanthosis Nigricans)</button> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_what_cause spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_right">
                <figure>
                  <img src={detail?.causesSection?.image} alt="image" />
                </figure>
              </div>
              <div className="wrap_left">
                <h2>{detail?.causesSection?.title}</h2>
                <p>{detail?.causesSection?.description}</p>

                <ul>
                  {detail?.causesSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="image" />
                      <div className="wrap_txt">
                        <p>{item?.title}</p>
                        <span>{item?.description}</span>
                      </div>
                    </li>
                  ))}
                </ul>
                {/* <p>
                Polycystic ovary syndrome (PCOS) is a problem with hormones that
                happens during the reproductive years. If you have PCOS, you may
                not have periods very often. Or you may have periods that last
                many days. You may also have too much of a hormone called
                androgen in your body.
              </p>
              <p>
                With PCOS, many small sacs of fluid develop along the outer edge
                of the ovary. These are called cysts. The small fluid-filled
                cysts contain immature eggs, called follicles. The follicles
                fail to regularly release eggs.
              </p>
              <ul>
                <li>
                  <img src={liheart} alt="" />
                  <span>Affects 1 in 10 women worldwide</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Can lead to infertility if left untreated</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Lifestyle changes can help manage symptoms</span>
                </li>
              </ul> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms wrapper_help spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.howToManage?.title}</h2>
                <p>{detail?.howToManage?.description}</p>
                {/* <p>
                Managing PCOS requires a combination of medical treatments and
                lifestyle modifications tailored to individual symptoms and
                health goals. While there is no permanent cure, the right
                treatment plan can help regulate hormones, improve fertility,
                and reduce long-term health risks.
              </p> */}
              </div>
              <div className="wrap_btn_card">
                {detail?.howToManage?.features.map((item, index) => (
                  <button key={index}>
                    <img src={item?.image} alt="image" />
                    <span>{item.title}</span>
                  </button>
                ))}
                {/* <button>
                <img src={helpicon} alt="" />
                <span>Lifestyle Changes</span>
              </button>
              <button className="active">
                <img src={helpicon2} alt="" />
                <span>Precision wellness trackers</span>
              </button>
              <button>
                <img src={helpicon1} alt="" />
                <span>Personalised medications</span>
              </button> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_pcos_system spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.howToReduce?.title}</h2>
                <p>{detail?.howToReduce?.description}</p>

                <ul>
                  {detail?.howToReduce?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="image" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                {/* <p>
                While there is no guaranteed way to prevent PCOS entirely,
                adopting a healthy lifestyle can significantly reduce its
                symptoms and long-term complications. Managing hormonal
                imbalances, insulin resistance, and inflammation through diet,
                exercise, and stress management is key. Here are some effective
                preventive measures:
              </p> 
              <ul>
                <li>
                  <img src={liheart} alt="" />
                  <span>Eat a balanced, low-carb diet</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Exercise regularly (Strength training & Cardio)</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Manage stress (Yoga, Meditation)</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Get enough sleep</span>
                </li>
                <li>
                  <img src={liheart} alt="" />
                  <span>Maintain a healthy weight</span>
                </li>
              </ul>
              */}
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.howToReduce?.image} alt="image" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="expert_sec">
          <div className="container">
            <div className="page_title">
              <h2>Get Expert Guidance for Endometriosis Care</h2>
              <div className="btn-box">
                <Link to="/login" className="button blue">
                  Schedule a Consultation
                </Link>
              </div>
            </div>
          </div>
        </section> */}

        {/* FAQ */}
        <FAQ type={"endometriosis"} />
      </div>
    </>
  );
};

export default Endometriosis;
